module.exports = __webpack_public_path__ + "static/media/hoffson_work.7cdaf520.jpg";